<template>
    <div class="subscribe-page ac">
      <div class="subscribe-page ac">
        <div class="logo" style="padding-top: 40px;">
          <img src="../../static/images/logo.png">
        </div>
        <div class="subTips mt50"><strong>" {{$t('subTips')}} "</strong></div>
        <div class="ac mt50">
            <img style="width: 80%;" src="../../static/images/landing-c.png">
        </div>
        <div class="unsub-btn por" style="margin-top:-160px">
          <div class="button" @click="getShowLogin">{{$t('Register')}}</div>
        </div>
        <div class="ac sub-b disflex mt50">
          <router-link class="opt-a crfff" :to="{path:'/termsAndCondition'}">{{$t('TC')}}</router-link>
          <router-link class="opt-a crfff" :to="{path:'/faq'}">{{$t('FAQs')}}</router-link>
        </div>
    </div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

        return {
			notFound:false,

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){

	},
    methods: {
      getShowLogin(){
        window.location.href = "https://gwt.mygameempire.com/consent/page"
      },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/Home/homeData',null,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
          });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/subscribe.vue